const digest = 'caede2473a1d8f5adbb5425e917c47b29ec152fcde4c3dfd84d11ba212b937d9';
const css = `._loader_1kftg_1{min-height:19.75rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'loader': '_loader_1kftg_1' };
export const loader = '_loader_1kftg_1';
export { css, digest };